<template>
  <div class="bg-settings">
    <b-container class="bg-settings mt-4">
     <b-row>
        <b-col cols="12" class="d-flex align-items-center">
          <div class="p2">
            <span class="page-title">{{ title }}</span>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <StoryInsightsForm />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import StoryInsightsForm from '@/components/StoryInsightsForm';

export default {
  name: 'StoryInsights',
  components: {
    StoryInsightsForm,
  },
  data() {
    return {
      title: 'Instagram Insights',
    };
  },
  methods: {
    ...mapActions(['getInstagramPages', 'getInstagramMetadata', 'getInstagramPosts', 'getInstagramProfile']),
  },
  async created() {
    await this.getInstagramPages();
    await this.getInstagramMetadata();
    await this.getInstagramPosts();
    await this.getInstagramProfile();
  },

};
</script>

<style lang="scss">
.app-content,
.bg-settings {
  background: #e0e0e0;
}
</style>
